import axios from 'axios';
import config from '../constants/config';

const api = axios.create({
    baseURL: config.API_URL,
    headers: {
        'Accept': 'application/json',
        'X-Theatron': config.API_KEY,
    },
    // withCredentials: true,
})

api.updateToken = (token) => {
    if(!token) {
        delete api.defaults.headers['Authorization'];
        return;
    }
    api.defaults.headers['Authorization'] =  `Bearer ${token}`;
}

export default api;
